<template>
  <div>
    <span class="my-checkbox">
      <input
        class="my-checkbox-input"
        type="checkbox"
        v-model="model"
        :value="label"
        :name="name"
        @change="handleChange"
      />
      <span class="my-checkbox-core"></span>
    </span>
  </div>
</template>

<script>
import Emitter from '../emitter';
export default {
  name: 'CheckBox',
  mixins: [Emitter],
  props: {
    value: {},
    label: {},
    name: String
  },
  data () {
    return {
    }
  },
  computed: {
    model: {
      get() {
        return this._checkboxGroup ? this._checkboxGroup.value : this.value;
      },
      set(val) {
        if (this._checkboxGroup) {
          this.dispatch('MyCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }
      }
    },
    _checkboxGroup() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'MyCheckboxGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    }
  },
  methods: {
    handleChange(ev) {
      this.$emit('change', ev.target.checked, ev);
      this.$nextTick(() => {
        if (this._checkboxGroup) {
          this.dispatch('MyCheckboxGroup', 'change', [this._checkboxGroup.value]);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-checkbox{
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
  }
  .my-checkbox-input{
    position: absolute;
    width: 20px;
    height: 20px;
    opacity: 0;
    z-index: 2;
  }
  .my-checkbox-input:checked + .my-checkbox-core{
    background-color: rgb(14, 137, 252);
    border-color: rgb(14, 137, 252);
  }
  .my-checkbox-input:checked + .my-checkbox-core::after{
    border-color: #fff;
    transform: rotate(45deg) scale(1);
  }
  .my-checkbox-core{
    display: inline-block;
    background-color: #fff;
    border-radius: 100%;
    border: 1px solid #ccc;
    position: absolute;
    size: 20px;
    vertical-align: middle;
    width: 18px;
    height: 18px;
  }
  .my-checkbox-core::after {
    border: 2px solid transparent;
    border-left: 0;
    border-top: 0;
    content: " ";
    position: absolute;
    top: 1px;
    left: 5px;
    size: 4px 8px;
    transform: rotate(45deg) scale(0);
    transition: transform .2s;
    width: 6px;
    height: 11px;
  }
</style>
